/// <amd-module name="TFS/DRITools/RestClient/DRITools" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\dritools\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as DRITools from "TFS/DRITools/Contracts/DRITools";

export interface IDRIToolsRestClient extends IVssRestClient {
    /**
     * @param activityId - 
     */
    getCallGraphData(activityId: string): Promise<DRITools.CallgraphResults>;
    /**
     * @param userId - 
     * @param startTime - 
     * @param endTime - 
     * @param service - 
     */
    getUsageInsights(userId: string, startTime: Date, endTime: Date, service: string): Promise<{ [key: string] : any; }[]>;
}

class DRIToolsRestClient extends RestClientBase implements IDRIToolsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param activityId - 
     */
    public async getCallGraphData(
        activityId: string
        ): Promise<DRITools.CallgraphResults> {

        return this.beginRequest<DRITools.CallgraphResults>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/DRITools/Callgraph/{activityId}",
            routeValues: {
                activityId: activityId
            }
        });
    }

    /**
     * @param userId - 
     * @param startTime - 
     * @param endTime - 
     * @param service - 
     */
    public async getUsageInsights(
        userId: string,
        startTime: Date,
        endTime: Date,
        service: string
        ): Promise<{ [key: string] : any; }[]> {

        const queryValues: any = {
            startTime: startTime,
            endTime: endTime,
            service: service
        };

        return this.beginRequest<{ [key: string] : any; }[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/DRITools/Usage/{userId}",
            routeValues: {
                userId: userId
            },
            queryParams: queryValues
        });
    }

}

export const DRIToolsClientName = "IDRIToolsRestClient";

export function getDRIToolsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IDRIToolsRestClient {
    return pageContext.getRestClient<IDRIToolsRestClient>(DRIToolsClientName, options);
}

RestClients.add(DRIToolsClientName, { 
    factory: DRIToolsRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
